export default function MyWorkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00004 1.4545L1.45459 4.72723L8.00004 7.99995L14.5455 4.72723L8.00004 1.4545Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45459 11.2727L8.00004 14.5455L14.5455 11.2727"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45459 8.00003L8.00004 11.2728L14.5455 8.00003"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
